export default __webpack_public_path__ + "static/media/confectionery-badge-profile-image-wrapper.7a7e39a6.svg";